import { Component } from '@angular/core';

@Component({
  templateUrl: './tabs.html'  
})
export class TabsComponent { 

    constructor() { }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/tabs/tabs-component.ts